export const CHANGE_PASSWORD_FORM_INITIAL_VALUES = {
  oldPassword: '',
  newPassword: '',
  reEnterPassword: '',
};

export const RESET_FORM_ERROR_CODES = ['passwords_match', 'password_incorrect'];

export const CHANGE_PASSWORD_QUERY_KEY = ['change password'] as const;
